import api from 'Common/Client/Interceptor'

export const getOrganizationsReport = (params) => {
  return api.get('/indv/reports/organizations', { params })
}

export const downloadOrganizationsReport = (params) => {
  return api.get('/indv/reports/organizations/download', {
    params,
    responseType: 'blob',
    headers: {
      'Accept': 'application/pdf',
    }
  })
}